export default {
  tipo: 'PF',
  email: null,
  cpfCnpj: null,
  nomeRazaoSocial: null,
  funcao: '',
  isSocioRepresentanteLegal: '',
  endereco: {
    bairro: null,
    cep: null,
    complemento: null,
    logradouro: null,
    municipio: {
      id: null,
      nome: null,
      codigoEstado: null
    },
    numero: null,
    semNumero: false,
    uf: null
  },
  pessoaFisica: {
    id: null,
    nome: null,
    cpf: null,
    rg: null,
    nacionalidade: null,
    dataNascimento: null,
    orgaoExpedidor: {
      nome: null,
      estado: null
    },
    naturalidade: {
      id: null,
      nome: null,
      codigoEstado: null
    },
    ufNaturalidade: null,
    estadoCivil: null,
    possuiCertidaoObito: null,
    telefones: [],
    email: null
  },
  pessoaJuridica: {
    cnpj: null,
    razaoSocial: null,
    telefones: [],
    email: null
  },
  telefones: []
}



// WEBPACK FOOTER //
// ./src/screens/central/cadastros/para/empty/emptyPessoa.js